import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api';


export const getActiveAnnouncements = async (pageNum = 1, pageSize = 20, searchTerm = '', sortBy = '') => {
  try {
    const response = await axios.post(`${baseUrl}/Announcement/GetActiveAnnouncement`, {
      pageNum,
      pageSize,
      searchTerm,
      sortBy,
      startDate: "2020-03-20T22:10:19.398Z",
      endDate: "2026-03-20T22:10:19.398Z"
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching announcements:', error);
    throw error;
  }
};

export const getAnnouncementByGuid = async (guid) => {
  try {
    console.log('Sending request with guid:', guid);
    const response = await axios.post(`${baseUrl}/Announcement/GetAnnouncementByGuid`, {
      guid: guid
    });
    console.log('Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching announcement details:', error.response?.data || error.message);
    throw error;
  }
};
